"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialLoginType = exports.AuthProvider = void 0;
var types_1 = require("./types");
Object.defineProperty(exports, "SocialLoginType", { enumerable: true, get: function () { return types_1.LoginType; } });
var utils_1 = require("./utils");
var sessionStore_1 = __importDefault(require("./sessionStore"));
var popup_1 = __importDefault(require("./popup"));
var keystore_1 = require("@arcana/keystore");
var logger_1 = require("./logger");
var config_1 = __importDefault(require("./config"));
var oauthMeta_1 = require("./oauthMeta");
var localStore_1 = require("./localStore");
var errors_1 = require("./errors");
var AuthProvider = /** @class */ (function () {
    function AuthProvider(params) {
        this.appAddress = '';
        this.params = this.getParams(params);
        if (this.params.network === 'test') {
            (0, logger_1.setLogLevel)(logger_1.LOG_LEVEL.DEBUG);
            (0, logger_1.setExceptionReporter)((0, utils_1.getSentryErrorReporter)());
        }
        else {
            (0, logger_1.setLogLevel)(logger_1.LOG_LEVEL.NOLOGS);
        }
        this.logger = (0, logger_1.getLogger)('AuthProvider');
        this.store = new sessionStore_1.default(this.params.appID);
        this.localstore = new localStore_1.LocalStore(this.params.appID);
    }
    AuthProvider.init = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var provider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = new AuthProvider(params);
                        if (!(provider.params.flow == 'redirect')) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.checkRedirectMode()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, provider];
                }
            });
        });
    };
    AuthProvider.prototype.loginWithSocial = function (loginType) {
        return __awaiter(this, void 0, void 0, function () {
            var clientID, loginHandler, state, url, popup, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.checkAlreadyLoggedIn(loginType)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchClientID(loginType)];
                    case 2:
                        clientID = _a.sent();
                        this.logger.info('clientID', clientID);
                        loginHandler = (0, utils_1.getLoginHandler)(loginType, this.appAddress);
                        state = (0, utils_1.generateID)();
                        return [4 /*yield*/, loginHandler.getAuthUrl({
                                clientID: clientID,
                                redirectUri: this.params.redirectUri,
                                state: state,
                            })];
                    case 3:
                        url = _a.sent();
                        if (this.params.flow == 'redirect') {
                            this.localstore.set(types_1.StoreIndex.LOGIN_TYPE, loginType);
                            this.localstore.set(types_1.StoreIndex.STATE, state);
                            setTimeout(function () { return (window.location.href = url); }, 50);
                            return [2 /*return*/];
                        }
                        popup = new popup_1.default(url, state);
                        popup.open();
                        return [4 /*yield*/, popup.getWindowResponse(loginHandler.handleRedirectParams)];
                    case 4:
                        params = _a.sent();
                        return [4 /*yield*/, this.fetchInfoAndKey(loginHandler, params)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.getAvailableLogins = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.oauthStore.getLogins()];
                }
            });
        });
    };
    AuthProvider.prototype.getUserInfo = function () {
        var userInfo = this.store.get(types_1.StoreIndex.LOGGED_IN);
        if (userInfo) {
            var info = JSON.parse(userInfo);
            return info;
        }
        else {
            this.logger.error('Error: getUserInfo');
            throw new errors_1.ArcanaAuthException('Please initialize the sdk before fetching user info.');
        }
    };
    AuthProvider.prototype.isLoggedIn = function () {
        var userExists = this.store.get(types_1.StoreIndex.LOGGED_IN);
        return userExists ? true : false;
    };
    AuthProvider.prototype.logout = function () {
        this.store.clear();
    };
    AuthProvider.prototype.getPublicKey = function (_a) {
        var id = _a.id, verifier = _a.verifier;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.initKeyReconstructor()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, this.keyReconstructor.getPublicKey({ id: id, verifier: verifier })];
                }
            });
        });
    };
    AuthProvider.prototype.checkRedirectMode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, loginHandler, params, state, err;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        loginType = this.localstore.get(types_1.StoreIndex.LOGIN_TYPE);
                        if (!loginType) {
                            return [2 /*return*/];
                        }
                        loginHandler = (0, utils_1.getLoginHandler)(loginType, this.appAddress);
                        params = (0, utils_1.parseHash)(new URL(window.location.href));
                        if ((0, utils_1.isParamsEmpty)(params)) {
                            return [2 /*return*/];
                        }
                        state = this.localstore.get(types_1.StoreIndex.STATE);
                        err = (0, utils_1.validateParams)(params, state);
                        if (err) {
                            throw err;
                        }
                        return [4 /*yield*/, loginHandler.handleRedirectParams(params)];
                    case 2:
                        params = _a.sent();
                        return [4 /*yield*/, this.fetchInfoAndKey(loginHandler, params)];
                    case 3:
                        _a.sent();
                        this.cleanupUrlParams();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.getParams = function (p) {
        var params = __assign(__assign({}, p), { redirectUri: p.redirectUri
                ? p.redirectUri
                : window.location.origin + window.location.pathname, flow: p.flow ? p.flow : 'popup', network: p.network ? p.network : 'testnet' });
        return params;
    };
    AuthProvider.prototype.cleanupUrlParams = function () {
        var cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState(null, '', cleanUrl);
        this.localstore.delete(types_1.StoreIndex.LOGIN_TYPE);
    };
    AuthProvider.prototype.fetchInfoAndKey = function (handler, params) {
        return __awaiter(this, void 0, void 0, function () {
            var userInfo, privateKey, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 6]);
                        return [4 /*yield*/, this.getInfoFromHandler(handler, params)];
                    case 1:
                        userInfo = _a.sent();
                        this.logger.info('fetchInfoAndKey', {
                            id: userInfo.id,
                            token: params.id_token,
                        });
                        return [4 /*yield*/, this.getUserPrivateKey(userInfo.id, params.id_token, handler.loginType)];
                    case 2:
                        privateKey = _a.sent();
                        this.setKeyAndUserInfo({
                            privateKey: privateKey,
                            userInfo: userInfo,
                            loginType: handler.loginType,
                        });
                        return [3 /*break*/, 6];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(err_1)];
                    case 4: return [4 /*yield*/, handler.cleanup()];
                    case 5:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.initConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rpcUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCurrentConfig()];
                    case 1:
                        rpcUrl = _a.sent();
                        return [2 /*return*/, rpcUrl];
                    case 2:
                        e_1 = _a.sent();
                        this.logger.error('Error during config init', e_1);
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.initKeyReconstructor = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setAppAddress()];
                    case 1:
                        _a.sent();
                        if (!this.keyReconstructor) {
                            this.keyReconstructor = new keystore_1.KeyReconstructor({
                                appID: this.appAddress,
                                network: this.params.network || 'test',
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rpcUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.params.rpcUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initConfig()];
                    case 1:
                        rpcUrl = _a.sent();
                        this.params.rpcUrl = rpcUrl;
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.initKeyReconstructor()];
                    case 3:
                        _a.sent();
                        this.oauthStore = new oauthMeta_1.OAuthContractMeta(this.appAddress, this.params.rpcUrl);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.fetchClientID = function (loginType) {
        return __awaiter(this, void 0, void 0, function () {
            var clientID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.oauthStore.getClientID(loginType)];
                    case 1:
                        clientID = _a.sent();
                        if (!clientID) {
                            throw new errors_1.ArcanaAuthException("Client ID not found for " + loginType);
                        }
                        return [2 /*return*/, clientID];
                }
            });
        });
    };
    AuthProvider.prototype.setAppAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.appAddress) return [3 /*break*/, 2];
                        return [4 /*yield*/, getAppAddress(this.params.appID)];
                    case 1:
                        appAddress = _a.sent();
                        if (appAddress.length === 0) {
                            throw new errors_1.ArcanaAuthException('Address non-existent or invalid, are you sure the App ID referenced exists?');
                        }
                        this.appAddress = appAddress;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.checkAlreadyLoggedIn = function (loginType) {
        if (this.isLoggedIn()) {
            var storedUserInfo = this.getUserInfo();
            if (storedUserInfo.loginType === loginType) {
                return true;
            }
        }
        return false;
    };
    AuthProvider.prototype.setKeyAndUserInfo = function (userInfo) {
        this.store.set(types_1.StoreIndex.LOGGED_IN, JSON.stringify(userInfo));
    };
    AuthProvider.prototype.getInfoFromHandler = function (handler, params) {
        return __awaiter(this, void 0, void 0, function () {
            var userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!params.access_token) return [3 /*break*/, 2];
                        return [4 /*yield*/, handler.getUserInfo(params.access_token)];
                    case 1:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 2: throw new errors_1.ArcanaAuthException('access token missing');
                }
            });
        });
    };
    AuthProvider.prototype.getUserPrivateKey = function (id, token, loginType) {
        return __awaiter(this, void 0, void 0, function () {
            var data, logger, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !token || !loginType) {
                            return [2 /*return*/, Promise.reject('Invalid params')];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.keyReconstructor.getPrivateKey({
                                id: id,
                                idToken: token,
                                verifier: loginType,
                            })];
                    case 2:
                        data = _a.sent();
                        logger = (0, logger_1.getLogger)('getUserPrivateKey');
                        logger.info('return_data', data);
                        return [2 /*return*/, data.privateKey];
                    case 3:
                        e_2 = _a.sent();
                        this.logger.error("Error during getting pvt key", { e: e_2 });
                        return [2 /*return*/, Promise.reject(new utils_1.ArcanaException('Error during getting user key'))];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.handleRedirectPage = utils_1.handleRedirectPage;
    return AuthProvider;
}());
exports.AuthProvider = AuthProvider;
var getAppAddress = function (appID) { return __awaiter(void 0, void 0, void 0, function () {
    var res, json, address, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch(config_1.default.gatewayUrl + "/get-address/?id=" + appID)];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                json = _a.sent();
                address = json === null || json === void 0 ? void 0 : json.address;
                if (!address) {
                    throw new utils_1.ArcanaException("Invalid appID: " + appID);
                }
                if (!address.startsWith('0x')) {
                    address = '0x' + address;
                }
                return [2 /*return*/, address];
            case 3:
                e_3 = _a.sent();
                throw new utils_1.ArcanaException("Invalid appID: " + appID);
            case 4: return [2 /*return*/];
        }
    });
}); };
var getCurrentConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, json, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch(config_1.default.gatewayUrl + "/get-config/")];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                json = _a.sent();
                if (!json.RPC_URL) {
                    throw new utils_1.ArcanaException('Error during fetching config');
                }
                return [2 /*return*/, json.RPC_URL];
            case 3:
                e_4 = _a.sent();
                throw new utils_1.ArcanaException("Error during fetching config");
            case 4: return [2 /*return*/];
        }
    });
}); };
